import React from "react";
import FormGroup from "./FormGroup";
import Checkbox from "./Checkbox";

export default function ValueToggle({
  FormControl,
  value,
  defaultValue,
  onFocus,
  onBlur,
  onChange,
  required,
  disabled,
  readOnly,
  ...props
}) {
  return (
    <div className="fields inline">
      <Checkbox
        checked={value !== null}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(checked) => onChange(checked ? defaultValue : null)}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        toggle
      />
      <span style={{ visibility: value === null ? "hidden" : "visible" }} className="u-marginLeft">
        <FormControl
          {...props}
          value={value}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
        />
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/ValueToggle.jsx